import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [expandedSection, setExpandedSection] = useState('COMPANY');
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleScrollLink = (target) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(target);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const footerSections = {
    COMPANY: [
      { label: 'About Us', type: 'route', path: '/company-profile' },
      { label: 'Locate Us', type: 'route', path: '/locate-us' },
      { label: 'Careers', type: 'route', path: '/careers' }
    ],
    SOLUTIONS: [
      { label: 'Loans', type: 'scroll', target: 'financial-solutions' },
      { label: 'Insurance', type: 'scroll', target: 'financial-solutions' },
      { label: 'Payments', type: 'scroll', target: 'financial-solutions' }
    ],
    'TOOLS & RESOURCES': [
      { label: 'ABC of Money', type: 'scroll', target: 'abcd-money' },
      { label: 'ABC of Calculators', type: 'scroll', target: 'calculators' },
      { label: 'Free Credit Score', status: 'coming-soon' }
    ],
    'USEFUL LINKS': [
      { label: 'Contact Us', type: 'route', path: '/company-profile' },
      { label: 'Terms & Conditions', type: 'route', path: '/terms-and-conditions' },
      { label: 'Sitemap', type: 'route', path: '/sitemap' }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">




          <div className="footer-menu">
            {Object.keys(footerSections).map((section) => (
              <div key={section} className="footer-column">
                <div
                  className="footer-heading"
                  onClick={() => toggleSection(section)}
                >
                  <span className={expandedSection === section ? 'expanded' : ''}>
                    {expandedSection === section ? '−' : '+'}
                  </span>
                  <h4>{section}</h4>
                </div>
                <ul className={`footer-links ${expandedSection === section ? 'expanded' : ''}`}>
                  {footerSections[section].map((link, index) => (
                    <li key={index}>
                      {link.status === 'coming-soon' ? (
                        <span className="footer-link-item disabled">
                          {link.label}
                          <span className="coming-soon-badge-footer">Coming Soon</span>
                        </span>
                      ) : link.type === 'route' ? (
                        <Link to={link.path} className="footer-link-item">
                          {link.label}
                        </Link>
                      ) : link.type === 'scroll' ? (
                        <button
                          onClick={() => handleScrollLink(link.target)}
                          className="footer-link-item footer-scroll-button"
                        >
                          {link.label}
                        </button>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © 2023, We Care Finserv Ltd. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
